module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_vm._l((_vm.imgs), function(value, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPage === key),
        expression: "showPage === key"
      }],
      key: key,
      staticClass: "imgs"
    }, [_c('img', {
      staticClass: "img",
      style: ({
        transform: ("scale(" + _vm.scale + ")")
      }),
      attrs: {
        "src": value.img
      }
    })])
  }), _c('div', {
    staticClass: "mask"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b87a7712","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = 517
// module chunks = 1